import './styles/@theme';

const SKELETON_TILE_KEYS = Array.from({ length: 20 }, (_, i) => `tile-${i}`);

export const SearchDrawerSkeleton = () => (
    <>
        {SKELETON_TILE_KEYS.map((key) => (
            <div key={key} className="search-drawer-skeleton__item" />
        ))}
    </>
);
